import { Link } from "react-router-dom";
import BaseLayout from "@/v2/components/BaseLayout";
import { AMNEN_LABELS } from "@/v2/taxonomy";

const SITE = "https://korthet.se";

// Perspektiv-slugs är inte ämnen och ska inte ha egna hubbsidor.
const EXCLUDED = new Set([
  "ekonomisk_fordelning",
  "individ_vs_kollektiv",
  "marknad_vs_reglering",
  "kort_vs_langsiktigt",
  "nationellt_vs_internationellt",
]);

export const TOPIC_SLUGS = Object.keys(AMNEN_LABELS).filter((s) => !EXCLUDED.has(s));

export default function TopicIndexPage() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "Ämnen – Korthet",
      url: `${SITE}/amnen`,
      inLanguage: "sv-SE",
    },
  ];

  return (
    <BaseLayout
      title="Ämnen – Korthet"
      description="Bläddra bland alla ämnen på Korthet: kriminalitet, politik, ekonomi, miljö, försvar och mer."
      canonicalPath="/amnen"
      jsonLd={jsonLd}
    >
      <h1 className="k2-h1">Ämnen</h1>
      <ul className="k2-topic-grid">
        {TOPIC_SLUGS.map((slug) => (
          <li key={slug}>
            <Link to={`/amne/${slug}`}>{AMNEN_LABELS[slug]}</Link>
          </li>
        ))}
      </ul>
    </BaseLayout>
  );
}
